module.exports = __webpack_public_path__ + "media/images/countrysquared/pa-e09ae1fb19214f4b6b98d506c93394ee.svg";